// import React, { useState, useContext, useEffect, forwardRef } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import CustomButton from "../Buttons/CustomButton";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { getOrdinalSuffix } from "../../Utility/Utils"; // Adjust the import path as necessary
// import { addMonths, format } from "date-fns"; // Import date-fns to handle date manipulation
// import { AgreementContext } from "./AgreementContext";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";

// const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
//   <button
//     type="button"
//     onClick={onClick}
//     ref={ref}
//     className="w-full text-left appearance-none bg-white border border-gray-300 rounded-lg py-3 pl-4 pr-10 text-gray-900 focus:outline-none"
//   >
//     {value || "Select date"}
//   </button>
// ));

// const ModifyAgreement = () => {
//   const navigate = useNavigate();
//   const { unitId } = useParams();
//   const { addAgreementDetails } = useContext(AgreementContext);
//   const { jwt } = useAuth();
//   const location = useLocation();
//   const existingAgreementData = location.state?.agreementData;

//   console.log(
//     "Modify Agreement page, existing agreement data -",
//     existingAgreementData
//   );

//   // --- Initial State Parsing ---
//   let initialStayingFrom = existingAgreementData?.stayingFrom
//     ? new Date(existingAgreementData.stayingFrom)
//     : new Date();

//   let initialDueDateValue;
//   if (existingAgreementData?.due_date) {
//     const day = parseInt(existingAgreementData.due_date, 10);
//     const baseDateForDue = addMonths(new Date(initialStayingFrom), 1);
//     initialDueDateValue = new Date(
//       baseDateForDue.getFullYear(),
//       baseDateForDue.getMonth(),
//       day
//     );
//   } else {
//     initialDueDateValue = addMonths(new Date(initialStayingFrom), 1);
//   }

//   let initialTenure = null;
//   let initialVacatingDate = null;
//   if (existingAgreementData?.tenure) {
//     const tenureString = existingAgreementData.tenure;
//     if (tenureString.toLowerCase() === "custom") {
//       initialTenure = "Custom";
//       if (existingAgreementData.vacating_on) {
//         initialVacatingDate = new Date(existingAgreementData.vacating_on);
//       }
//     } else {
//       const monthsMatch = tenureString.match(/(\d+)\s*Months/i);
//       if (monthsMatch && monthsMatch[1]) {
//         initialTenure = parseInt(monthsMatch[1], 10);
//       }
//     }
//   }
//   // --- End Initial State Parsing ---

//   const [monthlyRent, setMonthlyRent] = useState(
//     existingAgreementData?.rent?.[0]?.rent || ""
//   );
//   const [stayingFrom, setStayingFrom] = useState(initialStayingFrom);
//   const [dueDate, setDueDate] = useState(initialDueDateValue);
//   const [securityDeposit, setSecurityDeposit] = useState(
//     existingAgreementData?.security_deposit || ""
//   );
//   const [maintenanceCharge, setMaintenanceCharge] = useState(
//     existingAgreementData?.maintenance || ""
//   );
//   const [advanceRent, setAdvanceRent] = useState(
//     existingAgreementData?.is_advance_rent || false
//   );
//   const [tenure, setTenure] = useState(initialTenure);
//   const [vacatingDate, setVacatingDate] = useState(initialVacatingDate);
//   const [showDatePicker, setShowDatePicker] = useState(
//     initialTenure === "Custom" && initialVacatingDate // Show if initially custom and date exists
//   );

//   // Format the staying from date for display (Date MonthName Year)
//   const formattedStayingFromDisplay = format(
//     new Date(stayingFrom),
//     "d MMMM yyyy"
//   );

//   const placeholder = `Due on the ${getOrdinalSuffix(
//     new Date(dueDate).getDate()
//   )} of every month`;

//   // Initialize and update the dueDate whenever stayingFrom changes
//   useEffect(() => {
//     if (stayingFrom) {
//       const stayingFromDate = new Date(stayingFrom);
//       // Keep the current day of the month for dueDate, but update month/year
//       const currentDueDateDay = new Date(dueDate).getDate();
//       const nextMonthFromStayingFrom = addMonths(stayingFromDate, 1);
//       setDueDate(
//         new Date(
//           nextMonthFromStayingFrom.getFullYear(),
//           nextMonthFromStayingFrom.getMonth(),
//           currentDueDateDay
//         )
//       );
//     }
//   }, [stayingFrom]); // Removed dueDate from dependency array to avoid loops if user changes day

//   const handleStayingFromChange = (date) => {
//     setStayingFrom(date);
//     // Due date will be updated automatically via the useEffect hook
//   };

//   const handleTenureClick = (value) => {
//     if (value === "Custom") {
//       setShowDatePicker(true);
//       setTenure(value);
//     } else {
//       setTenure(value);
//       setVacatingDate(null); // Reset custom vacating date if a fixed tenure is chosen
//       setShowDatePicker(false);
//     }
//   };

//   const handleDateChange = (date) => {
//     setVacatingDate(date);
//     // setShowDatePicker(false); // Keep date picker open if user wants to change it again easily
//     setTenure("Custom");
//   };

//   const calculateVacatingDate = () => {
//     if (tenure === "Custom" && vacatingDate) {
//       return vacatingDate;
//     }
//     if (
//       !stayingFrom ||
//       !tenure ||
//       tenure === "Custom" ||
//       typeof tenure !== "number"
//     )
//       return null;
//     return addMonths(new Date(stayingFrom), tenure);
//   };

//   const vacatingDateCalculated = calculateVacatingDate();

//   const formatTenureForAPI = (tenureValue) => {
//     if (tenureValue === "Custom") {
//       return "Custom";
//     }
//     return `${tenureValue} Months`;
//   };

//   const formatDateForAPI = (date) => {
//     if (!date) return null;
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     const hours = String(d.getHours()).padStart(2, "0");
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     const seconds = String(d.getSeconds()).padStart(2, "0");
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   };

//   const handleContinue = async (e) => {
//     e.preventDefault();

//     const dayOfMonth = new Date(dueDate).getDate();
//     const formattedDueDate = dayOfMonth.toString();
//     const formattedTenure = formatTenureForAPI(tenure);
//     const formattedStayingFrom = formatDateForAPI(stayingFrom);
//     const finalVacatingDate =
//       tenure === "Custom" ? vacatingDate : vacatingDateCalculated;
//     const formattedVacatingDate = formatDateForAPI(finalVacatingDate);

//     const agreementDetails = {
//       agreementId: existingAgreementData?.agreement_id, // Include existing agreement ID for modification context
//       unitId,
//       monthlyRent,
//       stayingFrom: new Date(stayingFrom), // Send as Date object
//       formattedDueDate,
//       securityDeposit,
//       maintenanceCharge,
//       advanceRent,
//       tenure: formattedTenure,
//       vacatingDate: finalVacatingDate ? new Date(finalVacatingDate) : null, // Send as Date object
//     };

//     console.log("Modified Agreement Form Data for Context:", agreementDetails);

//     try {
//       const body = {
//         agreement_id: existingAgreementData?.agreement_id ?? "", // Important for backend to exclude this agreement
//         unit_id: unitId,
//         staying_from: formattedStayingFrom,
//         vacating_on: formattedVacatingDate,
//         tenure: formattedTenure,
//       };

//       console.log("API Call Body (coincide check):", body);

//       const response = await APICall(
//         "POST",
//         paths.agreement.coincide,
//         body,
//         undefined,
//         jwt
//       );

//       console.log("Agreement Coincide Response:", response);

//       if (response.coincides) {
//         alert(
//           "The modified agreement dates overlap with another existing agreement. Please choose different dates."
//         );
//         return;
//       }

//       addAgreementDetails(agreementDetails);
//       // navigate(`/MyProperties/${unitId}/AddAgreement/AddNewTenant`, {
//       navigate(`/my-properties/${unitId}/add-agreement/add-new-tenant`, {
//         state: { isModify: true },
//       }); // Pass isModify flag
//     } catch (error) {
//       console.error("Error checking agreement coincide or updating:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   const toggleAdvanceRent = () => {
//     setAdvanceRent((prev) => !prev);
//   };

//   return (
//     <form onSubmit={handleContinue} className="min-h-screen w-full p-6">
//       <div className="container mx-auto max-w-4xl">
//         <h2 className="text-xl font-semibold mb-4">Modify Agreement</h2>

//         <div className="mt-4 relative">
//           <label
//             htmlFor="monthlyRent"
//             className="block text-sm font-medium text-gray-700"
//           >
//             Monthly Rent Amount
//             <span className="text-red-500 ml-1">*</span>
//           </label>
//           <input
//             id="monthlyRent"
//             type="number"
//             required
//             value={monthlyRent}
//             onChange={(e) => setMonthlyRent(e.target.value)}
//             className="mt-1 pl-4 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>

//         <div className="mt-4">
//           <label
//             htmlFor="stayingFrom"
//             className="block text-sm font-medium text-gray-700"
//           >
//             Staying From
//           </label>
//           <div className="flex flex-col">
//             <DatePicker
//               id="stayingFrom"
//               selected={new Date(stayingFrom)}
//               onChange={handleStayingFromChange}
//               dateFormat="d MMMM yyyy"
//               className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//               required
//               customInput={<CustomDateInput />}
//             />
//             <p className="text-sm text-gray-500 mt-1">
//               {formattedStayingFromDisplay}
//             </p>
//           </div>
//         </div>

//         <div className="mt-4">
//           <label
//             htmlFor="dueDate"
//             className="block text-sm font-medium text-gray-700"
//           >
//             Due Date
//           </label>
//           <div className="flex flex-col">
//             <DatePicker
//               placeholderText={placeholder}
//               id="dueDate"
//               selected={new Date(dueDate)}
//               onChange={(date) => setDueDate(date)}
//               dateFormat="d MMMM yyyy" // Display format
//               className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//               required
//               customInput={<CustomDateInput />}
//             />
//             <p className="text-sm text-gray-600 mt-2">{placeholder}</p>
//           </div>
//         </div>

//         <div className="mt-4 relative">
//           <label
//             htmlFor="securityDeposit"
//             className="block text-sm font-medium text-gray-700"
//           >
//             Security Deposit
//             <span className="text-red-500 ml-1">*</span>
//           </label>
//           <input
//             id="securityDeposit"
//             type="number"
//             required
//             value={securityDeposit}
//             onChange={(e) => setSecurityDeposit(e.target.value)}
//             className="mt-1 pl-4 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>

//         <div className="mt-4 relative">
//           <label
//             htmlFor="maintenanceCharge"
//             className="block text-sm font-medium text-gray-700"
//           >
//             Maintenance Charge
//             <span className="text-red-500 ml-1">*</span>
//           </label>
//           <input
//             id="maintenanceCharge"
//             type="number"
//             required
//             value={maintenanceCharge}
//             onChange={(e) => setMaintenanceCharge(e.target.value)}
//             className="mt-1 pl-4 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>

//         <div className="text-xs flex flex-col items-start justify-between">
//           <div className="w-full mt-4 flex items-center justify-between">
//             <label htmlFor="advanceRent" className="block text-gray-700 mr-2">
//               Advance Rent
//             </label>
//             <div
//               onClick={toggleAdvanceRent}
//               className={`w-10 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer ${
//                 advanceRent ? "bg-green-500" : ""
//               }`}
//             >
//               <div
//                 className={`bg-white w-4 h-4 rounded-full shadow-md transform ${
//                   advanceRent ? "translate-x-4" : ""
//                 }`}
//               />
//             </div>
//           </div>
//           <p className="">
//             The rent will be collected in advance for the month of the agreement
//           </p>
//         </div>

//         <div className="mt-4 grid gap-4">
//           <label className="block text-sm font-medium text-gray-700 mb-2 col-span-full">
//             Tenure
//           </label>
//           <div className="grid grid-cols-2 gap-2 col-span-full">
//             {[3, 6, 11].map((months) => (
//               <button
//                 key={months}
//                 type="button"
//                 onClick={() => handleTenureClick(months)}
//                 className={`px-4 py-2 rounded-md ${
//                   tenure === months ? "bg-blue-500 text-white" : "bg-gray-200"
//                 }`}
//               >
//                 {months} Months
//               </button>
//             ))}
//             <button
//               type="button"
//               onClick={() => handleTenureClick("Custom")}
//               className={`px-4 py-2 rounded-md ${
//                 tenure === "Custom" ? "bg-blue-500 text-white" : "bg-gray-200"
//               }`}
//             >
//               Custom
//             </button>
//           </div>
//           {tenure && (tenure !== "Custom" || vacatingDate) && (
//             <p className="mt-2 col-span-full">
//               Vacating on:{" "}
//               {tenure === "Custom" && vacatingDate
//                 ? format(new Date(vacatingDate), "d MMMM yyyy")
//                 : vacatingDateCalculated
//                   ? format(new Date(vacatingDateCalculated), "d MMMM yyyy")
//                   : "Not set"}
//             </p>
//           )}
//           {tenure === "Custom" && showDatePicker && (
//             <div className="col-span-full">
//               <DatePicker
//                 selected={vacatingDate ? new Date(vacatingDate) : null}
//                 onChange={handleDateChange}
//                 dateFormat="d MMMM yyyy"
//                 placeholderText="Select custom vacating date"
//                 customInput={<CustomDateInput />}
//                 className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//           )}
//         </div>

//         <div className="flex justify-between items-center mt-6 mb-6">
//           <CustomButton
//             tailwindClasses={`bg-blue-500 text-white ${
//               !monthlyRent || !securityDeposit || !maintenanceCharge || !tenure
//                 ? "opacity-50 cursor-not-allowed"
//                 : ""
//             }`}
//             label="Save Changes & Continue" // Changed label
//             onClick={handleContinue}
//             disabled={
//               !monthlyRent || !securityDeposit || !maintenanceCharge || !tenure
//             }
//             type="submit"
//           />
//         </div>
//       </div>
//     </form>
//   );
// };

// export default ModifyAgreement;

import React, { useState, useContext, useEffect, forwardRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CustomButton from "../Buttons/CustomButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getOrdinalSuffix } from "../../Utility/Utils";
import { addMonths, format, parseISO } from "date-fns";
import { AgreementContext } from "./AgreementContext"; // Assuming this context is still relevant for storing modified details temporarily
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import { useAuth } from "../../Utility/AuthProvider";
import { useUnitDetails } from "../Properties/UnitDetailsContext";

const CustomDateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <button
    type="button"
    onClick={onClick}
    ref={ref}
    className="w-full text-left appearance-none bg-white border border-gray-300 rounded-lg py-3 pl-4 pr-10 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
  >
    {value || placeholder || "Select date"}
  </button>
));

const ModifyAgreement = () => {
  const navigate = useNavigate();
  const { unitId: paramsUnitId } = useParams(); // unitId from URL params
  const { addAgreementDetails } = useContext(AgreementContext);
  const { jwt } = useAuth();
  const location = useLocation();
  const { unitId } = useParams();

  const existingAgreementData = location.state?.agreementData;
  const unitDataForNextScreen = location.state?.unit; // Pass unit data to the next screen

  console.log(
    "ModifyAgreement Page: existingAgreementData ->",
    existingAgreementData
  );
  console.log("ModifyAgreement Page: unitData ->", unitDataForNextScreen);

  // --- Initial State Values from existingAgreementData ---
  const getInitialStayingFrom = () => {
    return existingAgreementData?.staying_from
      ? parseISO(existingAgreementData.staying_from)
      : new Date();
  };

  const getInitialDueDate = () => {
    const initialSf = getInitialStayingFrom();
    if (existingAgreementData?.due_date) {
      const day = parseInt(existingAgreementData.due_date, 10);
      // Try to set for the month after staying_from, or current month if staying_from is far in future
      let baseDateForDue = addMonths(initialSf, 1);
      if (baseDateForDue < new Date() && initialSf > new Date()) {
        // If staying from is future, due date month should also be future
        baseDateForDue = initialSf;
      }
      return new Date(
        baseDateForDue.getFullYear(),
        baseDateForDue.getMonth(),
        day
      );
    }
    return addMonths(initialSf, 1);
  };

  const getInitialTenureAndVacatingDate = () => {
    let tenureVal = null;
    let vacatingDateVal = null;
    if (existingAgreementData?.tenure) {
      const tenureString = existingAgreementData.tenure;
      if (tenureString.toLowerCase() === "custom") {
        tenureVal = "Custom";
        if (existingAgreementData.vacating_on) {
          vacatingDateVal = parseISO(existingAgreementData.vacating_on);
        }
      } else {
        const monthsMatch = tenureString.match(/(\d+)\s*Months/i);
        if (monthsMatch && monthsMatch[1]) {
          tenureVal = parseInt(monthsMatch[1], 10);
        }
      }
    }
    return { tenureVal, vacatingDateVal };
  };

  const { tenureVal: initialTenure, vacatingDateVal: initialVacatingDate } =
    getInitialTenureAndVacatingDate();

  const [monthlyRent, setMonthlyRent] = useState(
    existingAgreementData?.rent?.[0]?.rent?.toString() || ""
  );
  const [stayingFrom, setStayingFrom] = useState(getInitialStayingFrom());
  const [dueDate, setDueDate] = useState(getInitialDueDate());
  const [securityDeposit, setSecurityDeposit] = useState(
    existingAgreementData?.security_deposit?.toString() || ""
  );
  const [maintenanceCharge, setMaintenanceCharge] = useState(
    existingAgreementData?.maintenance?.toString() || ""
  );
  const [advanceRent, setAdvanceRent] = useState(
    existingAgreementData?.is_advance_rent || false
  );
  const [tenure, setTenure] = useState(initialTenure);
  const [vacatingDate, setVacatingDate] = useState(initialVacatingDate);
  const [showDatePicker, setShowDatePicker] = useState(
    initialTenure === "Custom" && !!initialVacatingDate
  );
  const [agreementValid, setAgreementValid] = useState(null); // For coincide check

  // --- Derived Values and Formatters ---
  const formattedStayingFromDisplay = format(stayingFrom, "d MMMM yyyy");
  const formattedDueDateDisplay = format(dueDate, "d MMMM yyyy");

  // --- useEffect Hooks ---
  // Update dueDate when stayingFrom changes (similar to AddAgreement)
  useEffect(() => {
    if (stayingFrom && !existingAgreementData?.due_date) {
      // Only auto-update if due_date wasn't prefilled
      const newDueDate = addMonths(new Date(stayingFrom), 1);
      setDueDate(newDueDate);
    }
  }, [stayingFrom, existingAgreementData?.due_date]);

  // Check for agreement coincidence
  useEffect(() => {
    const checkAgreementCoincide = async () => {
      if (!stayingFrom || !tenure || (tenure === "Custom" && !vacatingDate)) {
        setAgreementValid(null);
        return;
      }

      const vacatingDateToCheck =
        tenure === "Custom" ? vacatingDate : calculateVacatingDate();
      if (!vacatingDateToCheck) {
        setAgreementValid(null);
        return;
      }

      try {
        const body = {
          agreement_id: existingAgreementData?.agreement_id || "", // IMPORTANT: Pass existing agreement ID
          unit_id: paramsUnitId || existingAgreementData?.unit_id,
          staying_from: formatDateForAPI(stayingFrom),
          vacating_on: formatDateForAPI(vacatingDateToCheck),
          tenure: formatTenureForAPI(tenure),
        };

        console.log("ModifyAgreement Coincide Check API Body:", body);
        const response = await APICall(
          "POST",
          paths.agreement.coincide,
          body,
          undefined,
          jwt
        );
        console.log("ModifyAgreement Coincide Check Response:", response);
        setAgreementValid(!response.coincides);
      } catch (error) {
        console.error("Error checking agreement coincide:", error);
        setAgreementValid(null); // Error state
      }
    };

    const timeoutId = setTimeout(checkAgreementCoincide, 500); // Debounce
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    stayingFrom,
    tenure,
    vacatingDate,
    paramsUnitId,
    jwt,
    existingAgreementData?.agreement_id,
    existingAgreementData?.unit_id,
  ]);

  // --- Event Handlers ---
  const handleStayingFromChange = (date) => {
    setStayingFrom(date);
  };

  const handleDueDateChange = (date) => {
    setDueDate(date);
  };

  const handleTenureClick = (value) => {
    setTenure(value);
    if (value === "Custom") {
      setShowDatePicker(true);
      // setVacatingDate(null); // Optionally clear or keep existing custom date
    } else {
      setShowDatePicker(false);
      setVacatingDate(null); // Clear custom date if a fixed tenure is chosen
    }
  };

  const handleCustomVacatingDateChange = (date) => {
    // Renamed from handleDateChange to be specific
    setVacatingDate(date);
    setTenure("Custom"); // Ensure tenure is set to Custom
    // setShowDatePicker(false); // Optional: close picker after selection
  };

  const calculateVacatingDate = () => {
    if (tenure === "Custom" && vacatingDate) {
      return vacatingDate;
    }
    if (
      !stayingFrom ||
      !tenure ||
      tenure === "Custom" ||
      typeof tenure !== "number"
    ) {
      return null;
    }
    return addMonths(new Date(stayingFrom), tenure);
  };

  const vacatingDateCalculated = calculateVacatingDate();

  const formatTenureForAPI = (tenureValue) => {
    if (tenureValue === "Custom") {
      return "Custom";
    }
    return `${tenureValue} Months`;
  };

  const formatDateForAPI = (date) => {
    if (!date) return null;
    return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
  };

  const toggleAdvanceRent = () => {
    setAdvanceRent((prev) => !prev);
  };

  // const handleContinue = async (e) => {
  //   e.preventDefault();

  //   if (agreementValid === false) {
  //     alert(
  //       "The modified agreement dates overlap with another existing agreement. Please choose different dates."
  //     );
  //     return;
  //   }

  //   const dayOfMonth = new Date(dueDate).getDate();
  //   const finalVacatingDate =
  //     tenure === "Custom" ? vacatingDate : vacatingDateCalculated;

  //   // This is the data structure AddMoreTenant expects for modifiedAgreementData
  //   const modifiedAgreementDetailsPayload = {
  //     // Fields expected by AddMoreTenant or subsequent overview screens
  //     // This should match the structure that `agreementBody` would have in a new agreement flow
  //     // Or structure it based on what your backend expects for an update if you were to send it directly
  //     agreement_id: existingAgreementData?.agreement_id, // Keep original ID
  //     unit_id: paramsUnitId || existingAgreementData?.unit_id,
  //     rent: [{ rent: parseFloat(monthlyRent) }], // Adjust if rent structure is different
  //     staying_from: formatDateForAPI(stayingFrom),
  //     vacating_on: formatDateForAPI(finalVacatingDate),
  //     tenure: formatTenureForAPI(tenure),
  //     due_date: dayOfMonth.toString(),
  //     security_deposit: parseFloat(securityDeposit),
  //     maintenance: parseFloat(maintenanceCharge),
  //     is_advance_rent: advanceRent,
  //     // Include any other fields that are part of the agreement and might be modified
  //   };

  //   // For AgreementContext (if used for temporary storage before final API call)
  //   const agreementDetailsForContext = {
  //     agreementId: existingAgreementData?.agreement_id,
  //     unitId: paramsUnitId || existingAgreementData?.unit_id,
  //     monthlyRent,
  //     stayingFrom, // Keep as Date object for context if needed elsewhere
  //     formattedDueDate: dayOfMonth.toString(),
  //     securityDeposit,
  //     maintenanceCharge,
  //     advanceRent,
  //     tenure: formatTenureForAPI(tenure), // Or raw tenure for context
  //     vacatingDate: finalVacatingDate, // Keep as Date object
  //   };

  //   console.log(
  //     "Modified Agreement Data (Payload for next step):",
  //     modifiedAgreementDetailsPayload
  //   );
  //   addAgreementDetails(agreementDetailsForContext); // Update context if still used

  //   // Navigate to the tenant management/review screen for modification
  //   // Assuming AddMoreTenant handles the modification flow
  //   navigate(
  //     `/dashboard/my-properties/${paramsUnitId}/add-agreement/add-new-tenant`,
  //     {
  //       state: {
  //         originalAgreement: existingAgreementData, // Pass the original agreement data
  //         modifiedAgreementData: modifiedAgreementDetailsPayload, // Pass the newly formed agreement data
  //         unit: unitDataForNextScreen, // Pass unit data
  //         isModifying: true, // Critical flag for AddMoreTenant
  //       },
  //     }
  //   );
  // };

  const handleContinue = async (e) => {
    e.preventDefault();

    const dayOfMonth = new Date(dueDate).getDate();
    const formattedDueDate = dayOfMonth.toString();
    const formattedTenure = formatTenureForAPI(tenure);
    const formattedStayingFrom = formatDateForAPI(stayingFrom);
    const finalVacatingDate =
      tenure === "Custom" ? vacatingDate : vacatingDateCalculated;
    const formattedVacatingDate = formatDateForAPI(finalVacatingDate);

    // Prepare modified agreement data in the same format as EditAgreementModal
    const modifiedAgreementData = {
      rent: monthlyRent,
      security_deposit: securityDeposit,
      maintenance: maintenanceCharge,
      due_date: formattedDueDate,
      tenure: formattedTenure,
      staying_from: formattedStayingFrom,
      vacating_on: formattedVacatingDate,
    };

    try {
      const body = {
        agreement_id: existingAgreementData?.agreement_id ?? "",
        unit_id: unitId,
        staying_from: formattedStayingFrom,
        vacating_on: formattedVacatingDate,
        tenure: formattedTenure,
      };

      console.log("API Call Body (coincide check):", body);

      const response = await APICall(
        "POST",
        paths.agreement.coincide,
        body,
        undefined,
        jwt
      );

      console.log("Agreement Coincide Response:", response);

      if (response.coincides) {
        alert(
          "The modified agreement dates overlap with another existing agreement. Please choose different dates."
        );
        return;
      }

      // Navigate to the new modification flow
      navigate(
        `/dashboard/agreements/${existingAgreementData?.agreement_id}/modify/review-tenants`,
        {
          state: {
            modifiedAgreementData,
            originalAgreement: existingAgreementData,
            isModifying: true,
          },
        }
      );
    } catch (error) {
      console.error("Error checking agreement coincide or updating:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const isFormValid =
    monthlyRent &&
    securityDeposit &&
    maintenanceCharge &&
    tenure &&
    (tenure !== "Custom" || vacatingDate) && // If custom, vacatingDate must be set
    agreementValid !== false;

  if (!existingAgreementData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading agreement data or agreement data not found...</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleContinue} className="min-h-screen w-full p-6">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-2xl font-semibold mb-6">Modify Agreement</h2>

        {/* Agreement Details Section */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <h3 className="text-lg font-medium mb-4">Agreement Details</h3>

          <div className="mb-4">
            <label
              htmlFor="monthlyRent"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Monthly Rent Amount <span className="text-red-500">*</span>
            </label>
            <input
              id="monthlyRent"
              type="number"
              required
              value={monthlyRent}
              onChange={(e) => setMonthlyRent(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter monthly rent amount"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="stayingFrom"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Staying From
            </label>
            <DatePicker
              id="stayingFrom"
              selected={stayingFrom}
              onChange={handleStayingFromChange}
              dateFormat="d MMMM yyyy"
              className="w-full"
              required
              customInput={<CustomDateInput />}
            />
            <p className="text-sm text-gray-500 mt-1">
              {formattedStayingFromDisplay}
            </p>
          </div>

          <div className="mb-4">
            <label
              htmlFor="dueDate"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Due Date
            </label>
            <DatePicker
              id="dueDate"
              selected={dueDate}
              onChange={handleDueDateChange}
              dateFormat="d MMMM yyyy" // User sees this format
              className="w-full"
              required
              customInput={
                <CustomDateInput placeholder={formattedDueDateDisplay} />
              }
            />
            <p className="text-sm text-gray-600 mt-1">
              Due on the {getOrdinalSuffix(new Date(dueDate).getDate())} of
              every month
            </p>
          </div>

          <div className="mb-4">
            <label
              htmlFor="securityDeposit"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Security Deposit <span className="text-red-500">*</span>
            </label>
            <input
              id="securityDeposit"
              type="number"
              required
              value={securityDeposit}
              onChange={(e) => setSecurityDeposit(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter security deposit amount"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="maintenanceCharge"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Maintenance Charge <span className="text-red-500">*</span>
            </label>
            <input
              id="maintenanceCharge"
              type="number"
              required
              value={maintenanceCharge}
              onChange={(e) => setMaintenanceCharge(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter maintenance charge"
            />
          </div>

          {agreementValid !== null && (
            <div
              className={`flex items-center p-3 rounded-lg mb-4 ${
                agreementValid
                  ? "bg-green-50 border border-green-200"
                  : "bg-red-50 border border-red-200"
              }`}
            >
              <div
                className={`w-5 h-5 rounded-full flex items-center justify-center mr-3 text-white ${
                  agreementValid ? "bg-green-500" : "bg-red-500"
                }`}
              >
                {agreementValid ? "✓" : "⚠"}
              </div>
              <span
                className={`text-sm font-medium ${
                  agreementValid ? "text-green-800" : "text-red-800"
                }`}
              >
                {agreementValid
                  ? "Lease dates are valid and do not conflict."
                  : "Lease dates conflict with an existing agreement. Please adjust."}
              </span>
            </div>
          )}
        </div>

        {/* Advance Rent Toggle */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <div className="flex items-center justify-between mb-2">
            <label
              htmlFor="advanceRent"
              className="text-lg font-medium text-gray-900"
            >
              Advance Rent
            </label>
            <div
              onClick={toggleAdvanceRent}
              className={`relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer transition-colors ${
                advanceRent ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              <span className="sr-only">Advance Rent</span>
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                  advanceRent ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </div>
          </div>
          <p className="text-sm text-gray-600">
            The rent will be collected in advance for the month of the agreement
          </p>
        </div>

        {/* Tenure Selection */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <label className="block text-lg font-medium text-gray-900 mb-4">
            Tenure <span className="text-red-500">*</span>
          </label>
          <div className="grid grid-cols-2 gap-3 mb-4">
            {[3, 6, 11].map((months) => (
              <button
                key={months}
                type="button"
                onClick={() => handleTenureClick(months)}
                className={`px-4 py-3 rounded-lg border-2 font-medium transition-colors ${
                  tenure === months
                    ? "border-blue-500 bg-blue-50 text-blue-700"
                    : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                {months} Months
              </button>
            ))}
            <button
              type="button"
              onClick={() => handleTenureClick("Custom")}
              className={`px-4 py-3 rounded-lg border-2 font-medium transition-colors ${
                tenure === "Custom"
                  ? "border-blue-500 bg-blue-50 text-blue-700"
                  : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              Custom
            </button>
          </div>

          {tenure === "Custom" && showDatePicker && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Custom Vacating Date{" "}
                <span className="text-red-500">*</span>
              </label>
              <DatePicker
                selected={vacatingDate}
                onChange={handleCustomVacatingDateChange}
                dateFormat="d MMMM yyyy"
                placeholderText="Select custom vacating date"
                customInput={<CustomDateInput />}
                className="w-full" // DatePicker itself doesn't use className directly, CustomInput does
                minDate={addMonths(stayingFrom, 1)} // Vacating date should be after staying from
              />
            </div>
          )}

          {tenure && (tenure !== "Custom" || vacatingDate) && (
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-sm font-medium text-gray-700">
                Vacating on:{" "}
                <span className="font-normal">
                  {tenure === "Custom" && vacatingDate
                    ? format(vacatingDate, "d MMMM yyyy")
                    : vacatingDateCalculated
                      ? format(vacatingDateCalculated, "d MMMM yyyy")
                      : "Not set"}
                </span>
              </p>
            </div>
          )}
        </div>

        <div className="flex justify-end mt-8 mb-6">
          <CustomButton
            tailwindClasses={`px-8 py-3 text-lg font-medium ${
              !isFormValid
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
            label="Save Changes & Continue"
            onClick={handleContinue} // Already handled by form onSubmit
            disabled={!isFormValid}
            type="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default ModifyAgreement;
